/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import TextWidget from './TextWidget';
import { uiSchemaProperties } from '../../../shared/enums/uiSchemaProperties';

export default function TextAreaWidget(props) {
  const { options } = props;

  const { uiSchema, rawErrors = [], rawHelp = [] } = props;

  const hasError = rawErrors?.length > 0 || uiSchema?.[uiSchemaProperties.UI_HELP_SEVERITY] === 'error';
  const hasWarning = rawHelp?.length > 0 && uiSchema?.[uiSchemaProperties.UI_HELP_SEVERITY] === 'info';

  return (
    <TextWidget multiline={true} minRows={options.rows || 5} {...props} hasError={hasError} hasWarning={hasWarning} />
  );
}
